<ng-container *ngIf="reviews">
  <div [id]="navLink.id" class="ds-grid mx-auto container-fluid">
    <div class="row justify-content-center">
      <div class="col-lg-9  mx-auto">
        <h2 class="text-center ds-heading--l pt-7 mb-6">
          {{navLink.headline | cxTranslate: navLink.headlineParams}}
        </h2>
      </div>
    </div>
    <div *ngIf="reviewTexts" class="row justify-content-center align-content-center">
      <div *ngIf="reviews.meta.record_count > 0">
        <div *ngIf="reviewTexts?.sectionDescription" class="col-12 mb-5 ds-body--l text-center mx-auto">
          <p>{{reviewTexts.sectionDescription}}</p>
        </div>
      </div>

      <div class="col-lg-9 mx-auto">
        <dcp-first-review *ngIf="reviews.meta.record_count === 0"
                          [btnText]="reviewTexts?.ctaText"
                          [g2Product]="reviews.meta.product"
                          [infoText]="reviewTexts?.infoText"
                          [pageCount]="pageCount"
                          class="mb-6">
        </dcp-first-review>
        <div *ngIf="reviews.meta.record_count > 0">
          <span class="separator"></span>
          <dcp-review-summary [ctaText]="reviewTexts?.ctaText"
                              [g2Meta]="reviews.meta"
                              [infoText]="reviewTexts?.infoText"
                              class="separator"></dcp-review-summary>
          <div class="mt-6">
            <h3 class="ds-heading--m mb-5 mb-md-3">{{reviewTexts?.subSectionTitle}}</h3>
            <p class="mb-5 mb-md-3">{{'productReview.reviewsCollectedAndHosted' | cxTranslate}} <span
              (click)="openRedirectToG2(reviews.meta.product.g2crowd_url)"
              (keyup.enter)="openRedirectToG2(reviews.meta.product.g2crowd_url)"
              [tabIndex]="0"
              class="btn-link ds-cursor--pointer focusable focusable__element offset-none"
            >{{'productReview.G2Com' | cxTranslate}}{{'common.dot' | cxTranslate}}</span>
            </p>
            <div *ngFor="let review of reviews.data" class="mt-5">
              <dcp-review-preview [limitedHtmlSiblings]="limitedTextComponents"
                                  [reviewAnswerOrder]="reviewAnswerOrder"
                                  [review]="review"
                                  class="mt-5">
              </dcp-review-preview>
            </div>
            <div class="mt-6">
              <dcp-pagination
                (viewPageEvent)="pageChange($event)"
                *ngIf="reviews.meta.page_count > 1"
                [pagination]="{currentPage: currentPage, totalPages: pageCount}"
              >
              </dcp-pagination>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="ds-shadow mt-6"></div>
</ng-container>
